import {
  captureException,
  init,
  setExtras,
  setUser,
  wrapCreateBrowserRouterV7,
} from '@sentry/react';
import { createBrowserRouter } from 'react-router-dom';

import { sentryOptions } from '../constants/sentryOptions';
import { ErrorContext } from '../types/ErrorContext';
import { ErrorReporter } from '../types/ErrorReporter';

export const sentryErrorReporter: ErrorReporter = {
  captureException: (error, context?: ErrorContext): void => {
    captureException(error, context);
  },

  init: (): void => {
    init(sentryOptions);
  },

  setUser: (user: { id: string; email?: string }): void => {
    setUser(user);
  },

  setAdditionalData: (data: Record<string, unknown>): void => {
    setExtras(data);
  },

  wrapCreateBrowserRouter: (
    createRouter: typeof createBrowserRouter,
  ): typeof createBrowserRouter => {
    return wrapCreateBrowserRouterV7(createRouter);
  },
};
